// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"40182602","404":"1f5d2803","787":"a72690cc"}[chunkId] + ".chunk.js";
};